import { isRecentlyBookedAppointment } from 'client-portal/utils/recently-booked-slot';
import Service, { service } from '@ember/service';

const AGREEMENT_ROUTES = new Set(['site.legal-agreements', 'site.license-agreement']);
const REDIRECT_CAPTURE_SKIP_ROUTES = new Set([...AGREEMENT_ROUTES, 'site.home']);

export default class BookingResumeService extends Service {
  @service session;
  @service router;

  // Thank-you resume is same-tab only. Never persist this to session.data/localStorage:
  // refresh or a new tab must land on appointments/documents, not confirmation.
  #agreementRedirect = null;
  #recentlyBookedSlot = null;

  get recentlyBookedSlot() {
    return this.#recentlyBookedSlot;
  }

  isAgreementRoute(routeName) {
    return AGREEMENT_ROUTES.has(routeName);
  }

  captureAgreementRedirect(transition) {
    let target = transition?.to;
    let targetName = target?.name;
    if (!targetName || REDIRECT_CAPTURE_SKIP_ROUTES.has(targetName)) return;

    let path = this.router
      .urlFor(targetName, ...Object.values(target.params ?? {}))
      .replace(/^\//, '');
    this.#agreementRedirect = path;
    this.#discardPersistedAgreementRedirect();
  }

  consumeRedirect() {
    let redirect = this.#agreementRedirect || this.session.get('data.redirect');

    this.#agreementRedirect = null;
    this.#discardPersistedAgreementRedirect();
    this.session.set('data.redirect', undefined);

    return redirect;
  }

  clearAgreementResumeRedirect() {
    this.#agreementRedirect = null;
    this.#discardPersistedAgreementRedirect();
  }

  isAgreementInterruptActive(transition) {
    return (
      this.isAgreementRoute(transition?.to?.name) ||
      this.isAgreementRoute(this.router.currentRouteName)
    );
  }

  setRecentlyBookedSlot(slot) {
    this.#recentlyBookedSlot = slot;
  }

  clearRecentlyBookedSlot() {
    this.#recentlyBookedSlot = null;
  }

  clearRecentlyBookedSlotIfMatching(appointment) {
    if (!isRecentlyBookedAppointment(appointment, this.#recentlyBookedSlot)) return;

    this.#recentlyBookedSlot = null;
  }

  reset() {
    this.#agreementRedirect = null;
    this.#recentlyBookedSlot = null;
    this.#discardPersistedAgreementRedirect();
  }

  #discardPersistedAgreementRedirect() {
    this.session.set('data.agreementResumeRedirect', undefined);
  }
}
